import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";

const planningStatusAPI = createApi({
    reducerPath: "planningStatusAPI",
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        getAllPlanningStatusList: builder.mutation({
            query: (data) => ({
                url: "/PlanningStatus/GetAllPlanningStatus",
                method: "POST",
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addPlanningStatus: builder.mutation({
            query: (data) => ({
                url: `/PlanningStatus/AddPlanningStatus`,
                method: "POST",
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getPlanningStatusById: builder.query({
            query: (planningStatusId) => ({
                url: `/PlanningStatus/GetPlanningStatusById?planningStatusId=${planningStatusId}`,
                method: "GET",
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updatePlanningStatus: builder.mutation({
            query: (data) => ({
                url: "/PlanningStatus/UpdatePlanningStatus",
                method: "POST",
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deletePlanningStatus: builder.mutation({
            query: (planningStatusId) => ({
                url: `/PlanningStatus/DeletePlanningStatus?planningStatusId=${planningStatusId}`,
                method: 'DELETE',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
});

export const {
    useGetAllPlanningStatusListMutation,
    useAddPlanningStatusMutation,
    useGetPlanningStatusByIdQuery,
    useUpdatePlanningStatusMutation,
    useDeletePlanningStatusMutation,
} = planningStatusAPI;

export default planningStatusAPI;
